import type { LocationQuery } from 'vue-router'
import type { VirementQueryDTO } from '@/features/api/extranet/dto/Virement/VirementQueryDTO'
import { useRechercheVirementStore } from './useRechercheVirementStore'
import { locationQueryValueToArray, parseIntWithDefault } from '@/features/shared/tools'
import type { PagedRequest } from '../storeRechercheBuilder'
import { provideLoadRechercheService } from '../rechercheRoutingServiceProvider'
import { buildRechercheRoutingService } from '../rechercheRoutingServiceBuilder'
import type { Periode } from '@/features/domaine/types/opco/shared/Periode'

export function useRechercheVirementRoutingService() {
  return buildRechercheRoutingService<VirementQueryDTO>(useRechercheVirementStore, parseLocationQuery)
}
provideLoadRechercheService('virement', useRechercheVirementRoutingService)

function parseLocationQuery(query: LocationQuery): PagedRequest<VirementQueryDTO> {
  const loadParams: PagedRequest<VirementQueryDTO> = {
    query: {
      search: locationQueryValueToArray(query.search),
      periodeDateEmission: (query.periodeDateEmission as Periode) ?? '',
      dateDebutDateEmission: (query.dateDebutDateEmission as string) ?? '',
      dateFinDateEmission: (query.dateFinDateEmission as string) ?? '',
    },
    orderBy: locationQueryValueToArray(query.orderBy, [])!, // verifier
    pagination: {
      pageNumber: parseIntWithDefault(query.pageNumber as string, 1)!,
      pageSize: parseIntWithDefault(query.pageSize as string) as number | undefined,
    },
  }
  return loadParams
}

